/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SystemToolbox {
    angular.module("meevo.plugins.systemToolbox", []);
}